export default __webpack_public_path__ + "guide--raster-rasters-are-pixels-960-a1aff2d45bdcaf729fd6bcc1bb981c81.png";